import styled from 'styled-components'

export const StyledUpload = styled.input`
  width: 100%;
  padding: 12px;
  margin: 3px 0;
  border: 1px #1377d4 solid;
  box-sizing: border-box;
`
